import { render } from "./IconOutstock.vue?vue&type=template&id=0b94f112"
import script from "./IconOutstock.vue?vue&type=script&lang=ts"
export * from "./IconOutstock.vue?vue&type=script&lang=ts"
script.render = render

export default script